export default __webpack_public_path__ + "static/media/doc-complete.f8bacf38.svg";